/**
 * @method getContextPath
 * @description 获取根路径
 * @return {String} - 应用页面的根路径 '/emap'
 */
// export const getContextPath = function () {
//   const path = window.location.pathname
//   const end = path.indexOf('/sys/')
//   return path.substring(0, end) || '/emap'
// }

/**
 * @method getAbsPath
 * @description 获取绝对路径
 * @param {String} pagePath 传入的相对路径
 * @return {String} - 绝对路径 "/emap/sys/student_app/modules/xsxxdbwh.do"
 */
export const getAbsPath = pagePath => {
  if (pagePath === undefined) {
    console && console.warn('WIS_EMAP_SERV.getAbsPath 传参为空');
    return;
  }

  if (pagePath.substring(0, 7) === 'http://' || pagePath.substring(0, 8) === 'https://' || pagePath.substring(0, 1) === '/') {
    return pagePath;
  } // return getAppPath() + '/' + pagePath


  return '/' + pagePath;
};
export const joinActionIdToDoUrl = (url, actionID) => {
  url = url.trim();

  if (/\.do$/.test(url)) {
    url = url.replace(/\.do$/, '/' + actionID + '.do');
  } else if (/\.do\?/.test(url)) {
    url = url.replace(/\.do\?/, '/' + actionID + '.do?');
  } else if (/\.do#/.test(url)) {
    url = url.replace(/\.do#/, '/' + actionID + '.do#');
  } else if (/\.do\/#/.test(url)) {
    url = url.replace(/\.do\/#/, '/' + actionID + '.do/#');
  }

  return url;
};